export default __webpack_public_path__ + "static/media/produccion.c69cbb69.png";